var influencer_iso_codes = {
	AF: 'AFN',
	AL: 'ALL',
	DZ: 'DZD',
	AS: 'USD',
	AD: 'EUR',
	AO: 'AOA',
	AI: 'XCD',
	AG: 'XCD',
	AR: 'ARS',
	AM: 'AMD',
	AW: 'AWG',
	AU: 'AUD',
	AT: 'EUR',
	AZ: 'AZN',
	BS: 'BSD',
	BH: 'BHD',
	BD: 'BDT',
	BB: 'BBD',
	BY: 'BYN',
	BE: 'EUR',
	BZ: 'BZD',
	BJ: 'XOF',
	BM: 'BMD',
	BT: 'BTN',
	BO: 'BOB',
	BA: 'BAM',
	BW: 'BWP',
	BV: 'NOK',
	BR: 'BRL',
	IO: 'GBP',
	VG: 'USD',
	BN: 'BND',
	BG: 'BGN',
	BF: 'XOF',
	BI: 'BIF',
	KH: 'KHR',
	CM: 'XAF',
	CA: 'CAD',
	CV: 'CVE',
	KY: 'KYD',
	CF: 'XAF',
	TD: 'XAF',
	CL: 'CLP',
	CN: 'CNY',
	CX: 'AUD',
	CC: 'AUD',
	CO: 'COP',
	KM: 'KMF',
	CG: 'XAF',
	CK: 'NZD',
	CR: 'CRC',
	HR: 'HRK',
	CU: 'CUC',
	CY: 'EUR',
	CS: 'CZK',
	CD: 'CDF',
	DK: 'DKK',
	DJ: 'DJF',
	DM: 'XCD',
	DO: 'DOP',
	EC: 'USD',
	EG: 'EGP',
	SV: 'SVC',
	ER: 'ERN',
	EE: 'EUR',
	ET: 'ETB',
	EU: 'EUR',
	FK: 'FKP',
	FO: 'DKK',
	FJ: 'FJD',
	FI: 'EUR',
	FR: 'EUR',
	FR: 'EUR',
	GF: 'EUR',
	PF: 'XPF',
	TF: 'EUR',
	GA: 'XAF',
	GM: 'GMD',
	GE: 'GEL',
	DE: 'EUR',
	GH: 'GHS',
	GI: 'GIP',
	UK: 'GBP',
	GR: 'EUR',
	GL: 'DKK',
	GD: 'XCD',
	GP: 'EUR',
	GU: 'USD',
	GT: 'GTQ',
	GG: 'GGP',
	GN: 'GNF',
	GW: 'XAF',
	GY: 'GYD',
	HT: 'HTG',
	HM: 'AUD',
	HN: 'HNL',
	HK: 'HKD',
	HU: 'HUF',
	IS: 'ISK',
	IN: 'INR',
	ID: 'IDR',
	IR: 'IRR',
	IQ: 'IQD',
	IE: 'EUR',
	IM: 'IMP',
	IL: 'ILS',
	IT: 'EUR',
	CI: 'XOF',
	JM: 'JMD',
	JP: 'JPY',
	JE: 'JEP',
	JO: 'JOD',
	KZ: 'KZT',
	KE: 'KES',
	KI: 'KID',
	KW: 'KWD',
	KG: 'KGS',
	LA: 'LAK',
	LV: 'EUR',
	LB: 'LBP',
	LS: 'LSL',
	LR: 'LRD',
	LY: 'LYD',
	LI: 'CHF',
	LT: 'LTL',
	LU: 'EUR',
	MO: 'MOP',
	MK: 'MKD',
	MG: 'MGA',
	MW: 'MWK',
	MY: 'MYR',
	MV: 'MVR',
	ML: 'XOF',
	MT: 'EUR',
	MH: 'USD',
	MQ: 'EUR',
	MR: 'MRU',
	MU: 'MUR',
	YT: 'EUR',
	MX: 'MXN',
	FM: 'USD',
	MD: 'MDL',
	MC: 'EUR',
	MN: 'MNT',
	ME: 'EUR',
	MS: 'XCD',
	MA: 'MAD',
	MZ: 'MZN',
	MM: 'MMK',
	NA: 'NAD',
	NR: 'AUD',
	NP: 'NPR',
	AN: 'ANG',
	NL: 'EUR',
	NC: 'XPF',
	NZ: 'NZD',
	NI: 'NIO',
	NE: 'XOF',
	NG: 'NGN',
	NU: 'NZD',
	NF: 'AUD',
	KP: 'KPW',
	MP: 'USD',
	NO: 'NOK',
	OM: 'OMR',
	PK: 'PKR',
	PW: 'USD',
	PS: 'ILS',
	PA: 'PAB',
	PG: 'PGK',
	PY: 'PYG',
	PE: 'PEN',
	PH: 'PHP',
	PN: 'NZD',
	PL: 'PLN',
	PT: 'EUR',
	PR: 'USD',
	QA: 'QAR',
	RE: 'EUR',
	RO: 'RON',
	RU: 'RUB',
	RW: 'RWF',
	LC: 'XCD',
	PM: 'EUR',
	SM: 'EUR',
	SA: 'SAR',
	SN: 'XOF',
	RS: 'RSD',
	SC: 'SCR',
	SL: 'SLL',
	SG: 'SGD',
	SX: 'ANG',
	SK: 'EUR',
	SI: 'EUR',
	SB: 'SBD',
	SO: 'SOS',
	ZA: 'ZAR',
	GS: 'GBP',
	KR: 'KRW',
	SS: 'SSP',
	RU: 'RUB',
	ES: 'EUR',
	LK: 'LKR',
	SH: 'SHP',
	ST: 'STN',
	KN: 'XCD',
	VC: 'XCD',
	SD: 'SDG',
	SR: 'SRD',
	SJ: 'NOK',
	SZ: 'SZL',
	SE: 'SEK',
	CH: 'CHF',
	SY: 'SYP',
	TW: 'TWD',
	TJ: 'TJS',
	TZ: 'TZS',
	TH: 'THB',
	TL: 'USD',
	TG: 'XOF',
	TK: 'NZD',
	TO: 'TOP',
	TT: 'TTD',
	TN: 'TND',
	TR: 'TRY',
	TM: 'TMT',
	TC: 'USD',
	TV: 'AUD',
	UG: 'UGX',
	UA: 'UAH',
	AE: 'AED',
	US: 'USD',
	UY: 'UYU',
	UM: 'USD',
	VI: 'USD',
	UZ: 'UZS',
	VU: 'VUV',
	VA: 'EUR',
	VE: 'VES',
	VN: 'VND',
	WF: 'XPF',
	EH: 'MAD',
	WS: 'WST',
	YE: 'YER',
	YU: 'YUN',
	ZM: 'ZMW',
	ZW: 'ZWL'
}

var influencer_currencies = {
	"USD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} USD"},
	"EUR":{"money_format":"{{amount}} €","money_with_currency_format":"&euro; {{amount}} EUR"},
	"GBP":{"money_format":"&pound;{{amount}}","money_with_currency_format":"&pound;{{amount}} GBP"},
	"CAD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} CAD"},
	"ALL":{"money_format":"Lek {{amount}}","money_with_currency_format":"Lek {{amount}} ALL"},
	"DZD":{"money_format":"DA {{amount}}","money_with_currency_format":"DA {{amount}} DZD"},
	"AFN":{"money_format":"&#65;&#102; {{amount}}","money_with_currency_format":"&#65;&#102; {{amount}} AFN"},
	"AOA":{"money_format":"Kz{{amount}}","money_with_currency_format":"Kz{{amount}} AOA"},
	"ARS":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} ARS"},
	"AMD":{"money_format":"{{amount}} AMD","money_with_currency_format":"{{amount}} AMD"},
	"AWG":{"money_format":"Afl{{amount}}","money_with_currency_format":"Afl{{amount}} AWG"},
	"AUD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} AUD"},
	"BBD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} Bds"},
	"AZN":{"money_format":"m.{{amount}}","money_with_currency_format":"m.{{amount}} AZN"},
	"BDT":{"money_format":"Tk {{amount}}","money_with_currency_format":"Tk {{amount}} BDT"},
	"BSD":{"money_format":"BS${{amount}}","money_with_currency_format":"BS${{amount}} BSD"},
	"BHD":{"money_format":"{{amount}} BD","money_with_currency_format":"{{amount}}0 BHD"},
	"BYN":{"money_format":"Br {{amount}}","money_with_currency_format":"Br {{amount}} BYN"},
	"BYR":{"money_format":"Br {{amount}}","money_with_currency_format":"Br {{amount}} BYR"},
	"BZD":{"money_format":"BZ${{amount}}","money_with_currency_format":"BZ${{amount}} BZD"},
	"BTN":{"money_format":"Nu {{amount}}","money_with_currency_format":"Nu {{amount}} BTN"},
	"BAM":{"money_format":"KM {{amount}}","money_with_currency_format":"KM {{amount}} BAM"},
	"BRL":{"money_format":"R$ {{amount}}","money_with_currency_format":"R$ {{amount}} BRL"},
	"BOB":{"money_format":"Bs{{amount}}","money_with_currency_format":"Bs{{amount}} BOB"},
	"BMD":{"money_format":"&#36; {{amount}}","money_with_currency_format":"&#36; {{amount}} BMD"},
	"BIF":{"money_format":"&#70;&#66;&#117; {{amount}}","money_with_currency_format":"&#70;&#66;&#117; {{amount}} BIF"},
	"BWP":{"money_format":"P{{amount}}","money_with_currency_format":"P{{amount}} BWP"},
	"BND":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} BND"},
	"CVE":{"money_format":"&#36; {{amount}}","money_with_currency_format":"&#36; {{amount}} CVE"},
	"KMF":{"money_format":"&#67;&#70; {{amount}}","money_with_currency_format":"&#67;&#70; {{amount}} KMF"},
	"CUC":{"money_format":"{{amount}} CUC","money_with_currency_format":"{{amount}} CUC"},
	"CUP":{"money_format":"{{amount}} CUP","money_with_currency_format":"{{amount}} CUP"},
	"CDF":{"money_format":"&#70;&#67; {{amount}}","money_with_currency_format":"&#70;&#67; {{amount}} CDF"},
	"DJF":{"money_format":"&#70;&#100;&#106; {{amount}}","money_with_currency_format":"&#70;&#100;&#106; {{amount}} DJF"},
	"ERN":{"money_format":"{{amount}}","money_with_currency_format":"{{amount}} ERN"},
	"FKP":{"money_format":"&#163; {{amount}}","money_with_currency_format":"&#163; {{amount}} FKP"},
	"GIP":{"money_format":"&#163; {{amount}}","money_with_currency_format":"&#163; {{amount}} GIP"},
	"XAU":{"money_format":"{{amount}} XAU","money_with_currency_format":"{{amount}} XAU"},
	"GGP":{"money_format":"{{amount}} GGP","money_with_currency_format":"{{amount}} GGP"},
	"GNF":{"money_format":"&#70;&#71; {{amount}}","money_with_currency_format":"&#70;&#71; {{amount}} GNF"},
	"HTG":{"money_format":"&#71; {{amount}}","money_with_currency_format":"&#71; {{amount}} HTG"},
	"XDR":{"money_format":"{{amount}} XDR","money_with_currency_format":"{{amount}} XDR"},
	"IDR":{"money_format":"{{amount}} IDR","money_with_currency_format":"Rp {{amount}} IDR"},
	"IQD":{"money_format":"&#1593;.&#1583; {{amount}}","money_with_currency_format":"&#1593;.&#1583; {{amount}} IQD"},
	"IMP":{"money_format":"{{amount}} IMP","money_with_currency_format":"{{amount}} IMP"},
	"LAK":{"money_format":"&#8365; {{amount}}","money_with_currency_format":"&#8365; {{amount}} LAK"},
	"LSL":{"money_format":"&#76; {{amount}}","money_with_currency_format":"&#76; {{amount}} LSL"},
	"LRD":{"money_format":"&#36; {{amount}}","money_with_currency_format":"&#36; {{amount}} LRD"},
	"LYD":{"money_format":"&#1604;.&#1583; {{amount}}","money_with_currency_format":"&#1604;.&#1583; {{amount}} LYD"},
	"MWK":{"money_format":"&#77;&#75; {{amount}}","money_with_currency_format":"&#77;&#75; {{amount}} MWK"},
	"MRO":{"money_format":"&#85;&#77; {{amount}}","money_with_currency_format":"&#85;&#77; {{amount}} MRO"},
	"KPW":{"money_format":"&#8361; {{amount}}","money_with_currency_format":"&#8361; {{amount}} KPW"},
	"OMR":{"money_format":"{{amount}} OMR","money_with_currency_format":"{{amount}} OMR"},
	"PAB":{"money_format":"&#66;&#47;&#46; {{amount}}","money_with_currency_format":"&#66;&#47;&#46; {{amount}} PAB"},
	"SHP":{"money_format":"&#163; {{amount}}","money_with_currency_format":"&#163; {{amount}} SHP"},
	"SVC":{"money_format":"&#36; {{amount}}","money_with_currency_format":"&#36; {{amount}} SVC"},
	"SLL":{"money_format":"&#76;&#101; {{amount}}","money_with_currency_format":"&#76;&#101; {{amount}} SLL"},
	"XAG":{"money_format":"{{amount}} XAG","money_with_currency_format":"{{amount}} XAG"},
	"SBD":{"money_format":"&#36; {{amount}}","money_with_currency_format":"&#36; {{amount}} SBD"},
	"SOS":{"money_format":"&#83; {{amount}}","money_with_currency_format":"&#83; {{amount}} SOS"},
	"SDG":{"money_format":"&#163; {{amount}}","money_with_currency_format":"&#163; {{amount}} SDG"},
	"SRD":{"money_format":"&#36; {{amount}}","money_with_currency_format":"&#36; {{amount}} SRD"},
	"SZL":{"money_format":"&#76; {{amount}}","money_with_currency_format":"&#76; {{amount}} SZL"},
	"TJS":{"money_format":"&#84;&#74;&#83; {{amount}}","money_with_currency_format":"&#84;&#74;&#83; {{amount}} TJS"},
	"TOP":{"money_format":"&#84;&#36; {{amount}}","money_with_currency_format":"&#84;&#36; {{amount}} TOP"},
	"TMT":{"money_format":"&#109; {{amount}}","money_with_currency_format":"&#109; {{amount}} TMT"},
	"UZS":{"money_format":"&#1083;&#1074; {{amount}}","money_with_currency_format":"&#1083;&#1074; {{amount}} UZS"},
	"YER":{"money_format":"&#65020; {{amount}}","money_with_currency_format":"&#65020; {{amount}} YER"},
	"BGN":{"money_format":"{{amount}} лв","money_with_currency_format":"{{amount}} лв BGN"},
	"MMK":{"money_format":"K{{amount}}","money_with_currency_format":"K{{amount}} MMK"},
	"KHR":{"money_format":"KHR{{amount}}","money_with_currency_format":"KHR{{amount}}"},
	"KYD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} KYD"},
	"XAF":{"money_format":"FCFA{{amount}}","money_with_currency_format":"FCFA{{amount}} XAF"},
	"CLP":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} CLP"},
	"CNY":{"money_format":"&#165;{{amount}}","money_with_currency_format":"&#165;{{amount}} CNY"},
	"COP":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} COP"},
	"CRC":{"money_format":"&#8353; {{amount}}","money_with_currency_format":"&#8353; {{amount}} CRC"},
	"HRK":{"money_format":"{{amount}} kn","money_with_currency_format":"{{amount}} kn HRK"},
	"CZK":{"money_format":"{{amount}} K&#269;","money_with_currency_format":"{{amount}} K&#269;"},
	"DKK":{"money_format":"{{amount}} DKK","money_with_currency_format":"kr.{{amount}}"},
	"DOP":{"money_format":"RD$ {{amount}}","money_with_currency_format":"RD$ {{amount}}"},
	"XCD":{"money_format":"${{amount}}","money_with_currency_format":"EC${{amount}}"},
	"EGP":{"money_format":"LE {{amount}}","money_with_currency_format":"LE {{amount}} EGP"},
	"ETB":{"money_format":"Br{{amount}}","money_with_currency_format":"Br{{amount}} ETB"},
	"XPF":{"money_format":"{{amount}} XPF","money_with_currency_format":"{{amount}} XPF"},
	"FJD":{"money_format":"${{amount}}","money_with_currency_format":"FJ${{amount}}"},
	"GMD":{"money_format":"D {{amount}}","money_with_currency_format":"D {{amount}} GMD"},
	"GHS":{"money_format":"GH&#8373;{{amount}}","money_with_currency_format":"GH&#8373;{{amount}}"},
	"GTQ":{"money_format":"Q{{amount}}","money_with_currency_format":"{{amount}} GTQ"},
	"GYD":{"money_format":"G${{amount}}","money_with_currency_format":"${{amount}} GYD"},
	"GEL":{"money_format":"{{amount}} GEL","money_with_currency_format":"{{amount}} GEL"},
	"HNL":{"money_format":"L {{amount}}","money_with_currency_format":"L {{amount}} HNL"},
	"HKD":{"money_format":"${{amount}}","money_with_currency_format":"HK${{amount}}"},
	"HUF":{"money_format":"{{amount}} Ft","money_with_currency_format":"{{amount}} Ft"},
	"ISK":{"money_format":"{{amount}} kr","money_with_currency_format":"{{amount}} kr ISK"},
	"INR":{"money_format":"Rs. {{amount}}","money_with_currency_format":"Rs. {{amount}}"},
	"IDR":{"money_format":"Rp {{amount}}","money_with_currency_format":"Rp {{amount}}"},
	"ILS":{"money_format":"{{amount}} NIS","money_with_currency_format":"{{amount}} NIS"},
	"JMD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} JMD"},
	"JPY":{"money_format":"&#165;{{amount}}","money_with_currency_format":"&#165;{{amount}} JPY"},
	"JEP":{"money_format":"&pound;{{amount}}","money_with_currency_format":"&pound;{{amount}} JEP"},
	"JOD":{"money_format":"{{amount}} JD","money_with_currency_format":"{{amount}}0 JOD"},
	"KZT":{"money_format":"{{amount}} KZT","money_with_currency_format":"{{amount}} KZT"},
	"KES":{"money_format":"KSh{{amount}}","money_with_currency_format":"KSh{{amount}}"},
	"KWD":{"money_format":"{{amount}}0 KD","money_with_currency_format":"{{amount}}0 KWD"},
	"KGS":{"money_format":"лв{{amount}}","money_with_currency_format":"лв{{amount}}"},
	"LVL":{"money_format":"Ls {{amount}}","money_with_currency_format":"Ls {{amount}} LVL"},
	"LBP":{"money_format":"L&pound;{{amount}}","money_with_currency_format":"L&pound;{{amount}} LBP"},
	"LTL":{"money_format":"{{amount}} Lt","money_with_currency_format":"{{amount}} Lt"},
	"MGA":{"money_format":"Ar {{amount}}","money_with_currency_format":"Ar {{amount}} MGA"},
	"MKD":{"money_format":"ден {{amount}}","money_with_currency_format":"ден {{amount}} MKD"},
	"MOP":{"money_format":"MOP${{amount}}","money_with_currency_format":"MOP${{amount}}"},
	"MVR":{"money_format":"Rf{{amount}}","money_with_currency_format":"Rf{{amount}} MRf"},
	"MXN":{"money_format":"$ {{amount}}","money_with_currency_format":"$ {{amount}} MXN"},
	"MYR":{"money_format":"RM{{amount}} MYR","money_with_currency_format":"RM{{amount}} MYR"},
	"MUR":{"money_format":"Rs {{amount}}","money_with_currency_format":"Rs {{amount}} MUR"},
	"MDL":{"money_format":"{{amount}} MDL","money_with_currency_format":"{{amount}} MDL"},
	"MAD":{"money_format":"{{amount}} Dhs","money_with_currency_format":"Dhs {{amount}} MAD"},
	"MNT":{"money_format":"{{amount}} &#8366","money_with_currency_format":"{{amount}} MNT"},
	"MZN":{"money_format":"{{amount}} Mt","money_with_currency_format":"Mt {{amount}} MZN"},
	"NAD":{"money_format":"N${{amount}}","money_with_currency_format":"N${{amount}} NAD"},
	"NPR":{"money_format":"Rs{{amount}}","money_with_currency_format":"Rs{{amount}} NPR"},
	"ANG":{"money_format":"&fnof;{{amount}}","money_with_currency_format":"{{amount}} NA&fnof;"},
	"NZD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} NZD"},
	"NIO":{"money_format":"C${{amount}}","money_with_currency_format":"C${{amount}} NIO"},
	"NGN":{"money_format":"&#8358;{{amount}}","money_with_currency_format":"&#8358;{{amount}} NGN"},
	"NOK":{"money_format":"kr {{amount}}","money_with_currency_format":"kr {{amount}} NOK"},
	"OMR":{"money_format":"{{amount}} OMR","money_with_currency_format":"{{amount}} OMR"},
	"PKR":{"money_format":"Rs.{{amount}}","money_with_currency_format":"Rs.{{amount}} PKR"},
	"PGK":{"money_format":"K {{amount}}","money_with_currency_format":"K {{amount}} PGK"},
	"PYG":{"money_format":"Gs. {{amount}}","money_with_currency_format":"Gs. {{amount}} PYG"},
	"PEN":{"money_format":"S/. {{amount}}","money_with_currency_format":"S/. {{amount}} PEN"},
	"PHP":{"money_format":"&#8369;{{amount}}","money_with_currency_format":"&#8369;{{amount}} PHP"},
	"PLN":{"money_format":"{{amount}} zl","money_with_currency_format":"{{amount}} zl PLN"},
	"QAR":{"money_format":"QAR {{amount}}","money_with_currency_format":"QAR {{amount}}"},
	"RON":{"money_format":"{{amount}} lei","money_with_currency_format":"{{amount}} lei RON"},
	"RUB":{"money_format":"&#1088;&#1091;&#1073;{{amount}}","money_with_currency_format":"&#1088;&#1091;&#1073;{{amount}} RUB"},
	"RWF":{"money_format":"{{amount}} RF","money_with_currency_format":"{{amount}} RWF"},
	"WST":{"money_format":"WS$ {{amount}}","money_with_currency_format":"WS$ {{amount}} WST"},
	"SAR":{"money_format":"{{amount}} SR","money_with_currency_format":"{{amount}} SAR"},
	"STD":{"money_format":"Db {{amount}}","money_with_currency_format":"Db {{amount}} STD"},
	"RSD":{"money_format":"{{amount}} RSD","money_with_currency_format":"{{amount}} RSD"},
	"SCR":{"money_format":"Rs {{amount}}","money_with_currency_format":"Rs {{amount}} SCR"},
	"SGD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} SGD"},
	"SYP":{"money_format":"S&pound;{{amount}}","money_with_currency_format":"S&pound;{{amount}} SYP"},
	"ZAR":{"money_format":"R {{amount}}","money_with_currency_format":"R {{amount}} ZAR"},
	"KRW":{"money_format":"&#8361;{{amount}}","money_with_currency_format":"&#8361;{{amount}} KRW"},
	"LKR":{"money_format":"Rs {{amount}}","money_with_currency_format":"Rs {{amount}} LKR"},
	"SEK":{"money_format":"{{amount}} kr","money_with_currency_format":"{{amount}} kr SEK"},
	"CHF":{"money_format":"SFr. {{amount}}","money_with_currency_format":"SFr. {{amount}} CHF"},
	"TWD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} TWD"},
	"THB":{"money_format":"{{amount}} &#xe3f;","money_with_currency_format":"{{amount}} &#xe3f; THB"},
	"TZS":{"money_format":"{{amount}} TZS","money_with_currency_format":"{{amount}} TZS"},
	"TTD":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} TTD"},
	"TND":{"money_format":"{{amount}} DT","money_with_currency_format":"{{amount}} DT"},
	"TRY":{"money_format":"{{amount}}TL","money_with_currency_format":"{{amount}}TL"},
	"UGX":{"money_format":"Ush {{amount}}","money_with_currency_format":"Ush {{amount}} UGX"},
	"UAH":{"money_format":"₴{{amount}}","money_with_currency_format":"₴{{amount}} UAH"},
	"AED":{"money_format":"Dhs. {{amount}}","money_with_currency_format":"Dhs. {{amount}} AED"},
	"UYU":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}} UYU"},
	"VUV":{"money_format":"${{amount}}","money_with_currency_format":"${{amount}}VT"},
	"VEF":{"money_format":"Bs. {{amount}}","money_with_currency_format":"Bs. {{amount}} VEF"},
	"VND":{"money_format":"{{amount}}&#8363;","money_with_currency_format":"{{amount}} VND"},
	"XBT":{"money_format":"{{amount}} BTC","money_with_currency_format":"{{amount}} BTC"},
	"XOF":{"money_format":"CFA{{amount}}","money_with_currency_format":"CFA{{amount}} XOF"},
	"ZMW":{"money_format":"K{{amount}}","money_with_currency_format":"ZMW{{amount}}"}
};